import AuthHelper from './AuthHelper';

export default (status, componentWhenNotLocked, componentWhenLocked) => {
	if (status === 'Done' && !AuthHelper.hasRight('Admin')) {
		return componentWhenLocked;
	}

	return componentWhenNotLocked;
};
